// @ts-nocheck
import { useState } from "react";
import { PageHeader } from "../components/layout/PageHeader";
import { useLang } from "../lib/lang";

export function AuthKey() {
  const { t } = useLang();
  const d = t.authKey;

  const [apiKey] = useState("wa_sk_live_" + "a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6");
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  const maskedKey = apiKey.slice(0, 10) + "••••••••••••••••••••••••" + apiKey.slice(-6);

  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <PageHeader title={d.title} />
      <div className="px-6 pb-6">
        <div className="max-w-2xl space-y-6">
          <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef] p-6">
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-sm font-semibold text-[#32325d]">{d.yourKey}</h4>
              <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-[#d4edda] text-[#155724]">{d.active}</span>
            </div>
            <p className="text-xs text-[#8898aa] mb-4">{d.keyHint}</p>
            <div className="bg-[#f8f9fe] border border-[#e9ecef] rounded-lg p-4 flex items-center justify-between gap-3">
              <code className="text-sm font-mono text-[#32325d] flex-1 break-all">{visible ? apiKey : maskedKey}</code>
              <div className="flex gap-2 shrink-0">
                <button onClick={() => setVisible(!visible)} className="w-8 h-8 flex items-center justify-center text-[#8898aa] hover:text-[#1171ef] hover:bg-white rounded-lg transition-colors">
                  <i className={`fas fa-${visible ? "eye-slash" : "eye"} text-sm`} />
                </button>
                <button onClick={handleCopy} className="w-8 h-8 flex items-center justify-center text-[#8898aa] hover:text-[#1171ef] hover:bg-white rounded-lg transition-colors">
                  <i className={`fas fa-${copied ? "check" : "copy"} text-sm ${copied ? "text-[#2dce89]" : ""}`} />
                </button>
              </div>
            </div>
            {copied && <p className="text-xs text-[#2dce89] mt-2 flex items-center gap-1"><i className="fas fa-check-circle" />{d.copied}</p>}
            <div className="mt-4 flex gap-2">
              <button className="gradient-danger text-white px-4 py-2 rounded-lg text-sm font-medium shadow-sm hover:opacity-90 flex items-center gap-2">
                <i className="fas fa-sync-alt" />{d.regenerate}
              </button>
            </div>
            <p className="text-xs text-[#f5365c] mt-2 flex items-center gap-1"><i className="fas fa-exclamation-triangle" />{d.warning}</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef] p-6">
            <h4 className="text-sm font-semibold text-[#32325d] mb-4">{d.usageTitle}</h4>
            <p className="text-xs text-[#8898aa] mb-3">{d.usageAuthHint}</p>
            <div className="bg-[#1e1e2e] rounded-lg p-4">
              <pre className="text-xs text-[#cdd6f4] font-mono whitespace-pre-wrap">{`curl -X POST https://api.wasender.app/v1/send \\
  -H "Authorization: Bearer ${visible ? apiKey : maskedKey}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "phone": "+1234567890",
    "message": "Hello from WaSender!"
  }'`}</pre>
            </div>
            <a href="#" className="text-sm text-[#1171ef] hover:underline mt-3 inline-flex items-center gap-1">
              <i className="fas fa-external-link-alt text-xs" />View full API documentation
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
